import React from 'react';
import { t } from 'i18next';

import { SelectChangeEvent, SelectProps } from '@mui/material';

import { statesUS } from '@util/regions';
import { Select } from 'ui';

interface StateSelectProps extends Omit<SelectProps<string>, 'onChange'> {
  helperText?: string;
  value?: string;
  name: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  clearable?: boolean;
  clearLabel?: string;
}

const stateOptions = statesUS.map(state => ({ value: state, label: state }));

export const USStateSelect = React.forwardRef<HTMLDivElement, StateSelectProps>(
  ({ error, helperText = '', ...props }, ref) => {
    return (
      <Select
        {...props}
        label={t('adminPanel.teams.addModal.state')}
        variant='outlined'
        error={error}
        options={stateOptions}
        ref={ref}
        helperText={helperText}
      />
    );
  },
);

USStateSelect.displayName = 'USStateSelect';
